import { RouteObject } from "react-router-dom";
import { internalCourseRoutes } from "./courses/routes";
import { internalUsersRoutes } from "./users/routes";

export const internalRoutes: RouteObject[] = [
  {
    path: "courses",
    children: internalCourseRoutes,
  },
  {
    path: "users",
    children: internalUsersRoutes,
  },
];
